(function ($) {

    $(document).ready(function () {

        $('.navbar .left-nav .left-nav-item > ul').css('display', 'none');
        $('.navbar .left-nav .left-nav-item .dropdown-expandable-menu').find('.fa').toggleClass('fa-chevron-up fa-chevron-down');


        $(".dropdown-expandable-menu").click(function () {

            $(this).next("ul").removeClass("dropdown-expandable-menu-open");
            $(this).next('ul').addClass("dropdown-expandable-menu-open").slideToggle();
            $(this).find('.fa').toggleClass('fa-chevron-up fa-chevron-down');
        });

        function heightCalc() {
            var windowHeight = $(window).height();
            var topbarHeight = $(".nav-top-bar").height();
            var mainRight = $(".nav-main-right").height();
            var navLeft = $(".nav-main-left").height();
            var width = $(window).width();
            if (width > 991) {
                if (windowHeight < mainRight) {
                    $(".nav-main-right").css({
                        "overflow-y": "scroll",
                        "max-height": windowHeight - 40
                    });
                }
                else {
                    $(".nav-main-right").css({
                        "overflow-y": "scroll",
                        "max-height": windowHeight - 40
                    });
                }
                if ((windowHeight < navLeft)) {
                    $(".nav-main-left").css({
                        "overflow-y": "scroll",
                        "max-height": windowHeight - 40
                    });
                }
                else {
                    $(".nav-main-left").css({
                        "overflow-y": "scroll",
                        "max-height": windowHeight - 40
                    });
                }

                if ($(".nav-main-left").parent().parent().parent("body").hasClass("on-page-editor") == false) {
                    $(".nav-main-left").parent().parent().parent("body").css("overflow-y", "hidden");
                }
                ShowLeftNav();
            }
            else {
                if (windowHeight < mainRight) {
                    $(".nav-main-right").css({
                        "max-height": ""
                    });
                }
                else {
                    $(".nav-main-right").css({
                        "max-height": ""
                    });
                }
                if ((windowHeight < navLeft)) {
                    $(".nav-main-left").css({
                        "max-height": ""
                    });
                }
                else {
                    $(".nav-main-left").css({
                        "max-height": ""
                    });
                }
                if ($(".nav-main-left").parent().parent().parent("body").hasClass("on-page-editor") == false) {
                    $(".nav-main-left").parent().parent().parent("body").css("overflow-y", "scroll");
                }
            }
        }
        function leftNavMobile() {
            var mainBarHeight = $(".nav-main-bar").css("min-height");
            /*if (leftNavMobileResize == true) {
                if ($(".menu-button").children().hasClass("fa-times")) {
                    $('.menu-button .fa-times').click();
                }
            }*/
            if (window.innerWidth > 991) {
                $(".nav-main-left").css({
                    "display": "",
                    "height": "unset",
                });
                $(".left-nav-menu").css("display", "block");
                $(".nav-main-right").css("width", "76%");


                $(".nav-main-left .nav-wrapper").css("display", "");
                $(".nav-main-left .nav-main-item").css("display", "");
                $(".nav-main-left .nav-main-search").css("display", "");
                $(".nav-main-left .navbar").css("display", "");
                $(".nav-main-left .nav-main-bar").css({
                    "display": "block",
                    "height": "",
                });

                $(".nav-main-left .left-nav-search").css("display", "");
                //$(".nav-main-left .left-nav-searchBox").css("display", "none");
                //$(".nav-main-right").removeClass("col-12 breakpoints bp-xs bp-max-xs");
                $(".left-nav-mobile").css("display", "none");
                $(".left-nav-mobile .nav-main-list-trigger").css("display", "none");
                $(".nav-row").addClass("row");
            }
            else {
                $(".left-nav-mobile").css("display", "block");
                $(".left-nav-menu").css("display", "none");
                $(".nav-main-left").css({
                    "display": "block",
                    "height": "0px",
                });
                $(".nav-main-left .nav-wrapper").css("display", "none");
                $(".nav-main-left .nav-main-item").css("display", "none");
                $(".nav-main-left .nav-main-search").css("display", "none");
                $(".nav-main-left .navbar").css("display", "none");
                $(".nav-main-left .nav-main-bar").css({
                    "display": "block",
                    "min-height": "0px",
                });
                $(".nav-main-left .left-nav-search").css("display", "none");
                //$(".nav-main-left .left-nav-searchBox").css("display", "none");
                $(".nav-main-right").css("width", "100%");
                //$(".nav-main-right").addClass("col-12 breakpoints bp-xs bp-max-xs");

                $(".left-nav-mobile .nav-main-list-trigger").css("display", "block");
                $(".nav-row").removeClass("row");
            }
        }

        //for add logo inside the na component
        function addLogo() {
            $("<nav class='navbar navbar-expand-lg navbar-light bg-light navbar-alignment nav-main-list-condensed navbar-header' aria-label=''></nav>").appendTo(".navbar-left-header .nav-main-bar");
            $(".navbar-left-header .component.logo").prependTo(".left-nav-mobile nav.navbar");
            $(".left-nav-mobile .nav-main-search-trigger").appendTo(".left-nav-mobile nav.navbar");
        }

        function leftNavActiveInit() {
            var $mainNavLinks = $(".left-nav .nav-link");
            if (!$mainNavLinks.length) return;
            var currentURL = location.href.replace(location.search, "").split("#")[0];
            var shortURL = currentURL.split("/");
            shortURL = shortURL.filter(Boolean);
            var shortURL_active = "/" + shortURL[shortURL.length - 1];
            if (window.location.hash !== "") {
                shortURL_active = shortURL_active + window.location.hash;
            }
            function compareSpacesToDashes(link1, link2) {
                if (link2.indexOf("-") > 0) {
                    link1 = link1.replace(/%20/g, "-");
                    link2 = link2.replace(/%20/g, "-");
                }
                return link1 === link2;
            }
            $mainNavLinks.each(function () {
                var targetEl = $(this);
                if (!targetEl.attr("href").includes("void(0)")) {
                    linkURL = targetEl.attr("href");
                    if (linkURL.substr(-1) === "/") {
                        linkURL = linkURL.substr(0, linkURL.length - 1);
                    }
                    if (linkURL !== undefined) {
                        shortLinkURL = linkURL.split("/");
                        finalLinkURL = "/" + shortLinkURL[shortLinkURL.length - 1];
                        if (linkURL) {
                            linkURL =
                                linkURL[linkURL.length - 1] === "/" ? linkURL.substring(0, linkURL[linkURL.length - 2]) : linkURL;
                            if (linkURL.indexOf("http") > -1) {
                                if (compareSpacesToDashes(currentURL, encodeURI(linkURL))) {
                                    $(this).addClass("leftnavlink_active");
                                    targetEl.attr("aria-current", "page");
                                }
                            } else if (
                                compareSpacesToDashes(shortURL_active, encodeURI(linkURL))
                            ) {
                                $(this).addClass("leftnavlink_active");
                                targetEl.attr("aria-current", "page");
                            } else if (
                                compareSpacesToDashes(shortURL_active, encodeURI(finalLinkURL))
                            ) {
                                $(this).addClass("leftnavlink_active");
                                targetEl.attr("aria-current", "page");
                            }
                        }
                    }
                }
            });
        }

        function leftNavActiveLinkMenuOpen() {
            $('.leftnavlink_active').parents('.dropdown-menu').each(function () {
                var target = $(this);
                target.addClass('nav-expandable-menu-open');
                target.css('display', 'block');
            });

            $(".leftnavlink_active").parents(".nav-expandable-menu").each(function(){
                var target = $(this);
                target.find('.fa').first().toggleClass('fa-chevron-up fa-chevron-down');
            });
        }

        //var leftNavMobileResize = false;

        $(document).ready(function () {
            heightCalc();
            leftNavMobile();
            leftNavActiveInit();
            addLogo();
            leftNavActiveLinkMenuOpen();
            //if ($(".main").find(".login-form")) {
            //    $(".nav-main-left").hide();
            //    $(".left-nav-menu").hide();
            //    $(".nav-main-right").css("width", "100%");
            //} else {
            //    $(".nav-main-left").hide();
            //    $(".left-nav-menu").hide();
            //    $(".nav-main-right").css("width", "100%");
            //}      
        });
        $(window).resize(function () {
            //leftNavMobileResize = true;
            heightCalc();
            leftNavMobile();

        });


    });

    if ($(".nav-main-left").parent().parent().parent("body").hasClass("on-page-editor")) {
        $(".nav-main-left").parent().parent().parent("body").css("overflow-y", "");
    }

    /*****************************************************/
    // functions for click of cross and bar icons goes
    /*****************************************************/

    function ShowLeftNav() {
        $(".nav-main-left .nav-main-bar").css({
            "display": "block",
            "width": "100%"
        });
        //var lastWidthCheckNav = window.innerWidth; // Track width changes

        var currentWidthNav = window.innerWidth;
        var currentHeightNav = window.innerHeight;

        // **Scenario 1: Prevent calls on iPad scroll**
        if (Math.abs(currentHeightNav - lastHeightCheck) < 50) {
            // If height change is small (likely an iPad scroll), ignore
            return;
        }

        // **Scenario 2: Allow function only on actual width resizes**
        if (currentWidthNav !== lastWidthCheck) {
            rearrangeOverflowedOverlays(true);
            lastWidthCheck = currentWidthNav;
        }
        $(".nav-main-right").css("width", "76%");
        //$(".menu-button").css({
        //    "z-index": "0",
        //    "left": "unset"
        //});

        $(".menu-button .fa-bars").css({
            "display": "block",
            "width": "100%"
        });
        if (($(".breadcrumb-panel").length > 0) && ($(".breadcrumb-panel").parents(".nav-main-right"))) {
            $(".menu-button").css("top", "unset");
        }
        // Update height check for future scroll detection
        lastHeightCheck = currentHeightNav;
    }
    $('body').on('click', '.menu-button .fa-bars', function () {

        ShowLeftNav();
        //$(".menu-button").children().toggleClass("fa-bars fa-times");
    });

    $('body').on('click', '.menu-button .fa-times', function () {
        $(".nav-main-left .nav-main-bar").css({
            "display": "none",
            "width": "0"
        });
        $(".nav-main-right").css("width", "100%");
        //$(".menu-button").children().toggleClass("fa-bars fa-times");
        //$(".menu-button").css({
        //    "z-index": "0",
        //    "left": "unset"
        //});
        if (($(".breadcrumb-panel").length > 0) && ($(".breadcrumb-panel").parents(".nav-main-right"))) {
            $(".menu-button").css("top", "2.6rem");
        }
    });


    /*****************************************************/
    //functions to hide and show cross based on data attr
    /*****************************************************/
    var stickyLeftNav = $("#nav-row").attr("data-stickyLaftNav");
    $(document).ready(function () {
        if (stickyLeftNav === "true") {
            $(".menu-button").css("display", "none");
        }
    });




    //for search box
    $(".nav-main-left .left-nav-search").click(function () {
        if ($(".left-nav-search").children(".fa-times").length > 0) {
            $(".left-nav-searchBox").css("display", "none");
        }
        else {
            $(".left-nav-searchBox").css("display", "block");
        }
        $(".left-nav-search").children().toggleClass("fa-times fa-search");
    });

    $('body').on('keypress', '.menu-button .fa-bars', function (e) {
        if (e.keyCode == 13) {
            $(".menu-button .fa-bars").click();
        }
    });
    $('body').on('keypress', '.menu-button .fa-times', function (e) {
        if (e.keyCode == 13) {
            $(".menu-button .fa-times").click();
        }
    });

    $(".nav-main-left .left-nav-search").keypress(function (e) {
        if (e.keyCode == 13) {
            $(".nav-main-left .left-nav-search").click();
        }
    });



}(window.jQuery));
